import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReporteCobranzaService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/reporte-cobranza';
    this.service_url = this.api_url + this.modulo_url;
  }

  getReporteCobranza(idObra, idProveedor, fechaInicial, fechaFinal) {
    let request = this.service_url + '/generar' +'?' +'fechaInicial=' + fechaInicial + '&fechaFinal=' + fechaFinal;
    if(idObra){
      request += '&obra=' + idObra;
    }
    if(idProveedor){
      request += '&proveedor=' + idProveedor;
    }
    return this.http.get(request, this.authService.getAuthHeaders());
  }

  getDetalleCobranza(idContrato, fechaFinal) {
    let request = this.service_url + '/detalle' + '?' + 'id_contrato=' + idContrato + '&fechaFinal=' + fechaFinal;
    return this.http.get(request, this.authService.getAuthHeaders());
  }

  /** Detalle de un renglon facturado a mano: no tiene contrato, va por cliente e inmueble. */
  getDetalleFacturadoDirecto(idProveedor, idObra, fechaFinal) {
    let request = this.service_url + '/detalle' + '?' + 'proveedor=' + idProveedor
      + '&obra=' + idObra + '&fechaFinal=' + fechaFinal;
    return this.http.get(request, this.authService.getAuthHeaders());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/reporte-cobranza.service.ts